<template>
	<router-link tags="a" to="/" class='header-title-link'>
		<h1 class="onestore-theme-no">
			<logo-svg></logo-svg>
			<span>onestore.io</span>
		</h1>
	</router-link>
</template>

<script>
const router = require("@/router");
const logger = require("@/utils/logger");

export default {
  methods: {
    goHome() {
      logger.log("Going home");
      router.push("/");
    }
  }
};
</script>

<style scoped>
.header-title-link:hover {
  text-decoration: none;
}
.header-title svg {
  width: 30px;
}
.header-title h1 {
  font-size: 2em;
  margin: 0px;
  display: flex;
  align-items: center;
}
.header-title h1 span {
  margin: 10px 0 10px 11px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/common/AppLogoName.vue